import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import router from './router';
import api from './services/auth-api';
import VueCookies from 'vue-cookies';
import { createBootstrap } from 'bootstrap-vue-next';
import BootstrapCompat, { compatVSelect, compatDatePicker } from '@/plugins/bootstrap-compat';
import vSelect from 'vue-select'
import DatePicker from 'vue-datepicker-next'
import Toast, { useToast, POSITION } from 'vue-toastification'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'vue-toastification/dist/index.css'
import 'vue-datepicker-next/index.css';
import 'vue-select/dist/vue-select.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import i18n from "./i18n";
import '@/styles/index.scss';
import store from "./store"; 
import { createSnotifyAdapter, setSnotify } from '@/plugins/snotify-adapter';

import { restoreAuthSession } from '@/utilsAuth';


NProgress.configure({ showSpinner: false, speed: 1000 })



const mountApp = async () => {
  const app = createApp(App);

  app.use(createBootstrap());
  app.use(BootstrapCompat);
  app.use(VueCookies);
  // Loaded on demand so ApexCharts stays out of the initial bundle
  // eslint-disable-next-line vue/multi-word-component-names
  app.component('apexchart', defineAsyncComponent(() => import('vue3-apexcharts')));
  app.use(Toast, {
    position: POSITION.TOP_CENTER,
    timeout: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    maxToasts: 5,
    newestOnTop: true,
  });
  app.use(store);
  app.use(i18n);
  app.use(router);

  app.component('v-select', compatVSelect(vSelect));
  app.component('Vue-date-picker', compatDatePicker(DatePicker));

  const snotify = createSnotifyAdapter(useToast());
  app.config.globalProperties.$api = api;
  app.config.globalProperties.$nprogress = NProgress;
  app.config.globalProperties.$snotify = snotify;
  app.config.errorHandler = (err) => {
    console.error('[Vue Error Handler]', err);
  };

  setSnotify(snotify);

  await restoreAuthSession();

  await store.dispatch("loadSimulatedSupplierFromCookies");
  app.mount('#app');
};

mountApp();
